import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../common/template/content';
import Tabs from '../common/tab/tabs';
import TabsHeader from '../common/tab/tabsHeader';
import TabsContent from '../common/tab/tabsContent';
import TabHeader from '../common/tab/tabHeader';
import TabContent from '../common/tab/tabContent';
import { init } from './logUsuarioActions';
import PermissaoUsuario from '../auth/permissao';

import List from './logUsuarioList';

// Componente customizado do SelectConfGrupoFisico apenas para esta tela
class SelectConfGrupoFisicoLog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: this.props.getConfig('grupo'),
    };
  }

  componentWillMount() {
    this.props.getGrupoFisicoList();
  }

  renderOptions() {
    const list = this.props.list || [];

    if (list.length === 0) {
      return <option value="">Carregando...</option>;
    }

    return list.map(grupo => (
      <option key={grupo.id} value={grupo.id}>
        {grupo.id} - {grupo.descricao}
      </option>
    ));
  }

  handleChange(event) {
    let changed = this.props.getConfig('grupo') !== event.target.value;
    this.setState({ value: event.target.value });
    this.props.setConfig('grupo', event.target.value);

    // Limpa os valores do controlador quando muda o grupo
    this.props.setConfig('cont', 0);
    this.props.setConfig('numCont', 0);
    this.props.setConfig('anel', 0);

    // Atualiza a lista de controladores para o novo grupo
    this.props.getConfControladorGrupoList(event.target.value);

    if (changed && this.props.onChange) {
      this.props.onChange(event.target.value);
    }
  }

  render() {
    return (
      <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0 }}>
        <label style={{ fontSize: '14px', color: '#333', fontWeight: 'normal', margin: 0, paddingRight: '5px' }}>
          Grupo Físico:
        </label>
        <select
          id={'selectConfGrupoFisicoLog'}
          name={'selectConfGrupoFisicoLog'}
          style={{
            width: '180px',
            height: '32px',
            padding: '4px 8px',
            fontSize: '13px',
            fontWeight: '600',
            border: '2px solid rgba(255, 255, 255, 0.4)',
            borderRadius: '4px',
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            color: '#333',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          }}
          className={'form-control'}
          onChange={event => {
            this.handleChange(event);
          }}
          value={this.state.value}
        >
          <option value="0">Todos</option>
          {this.renderOptions()}
        </select>
      </div>
    );
  }
}

// Conecta o componente customizado com o Redux
const mapStateToPropsGrupo = state => ({ list: state.grupoFisicoCad.list });
const mapDispatchToPropsGrupo = dispatch =>
  bindActionCreators(
    {
      getGrupoFisicoList: require('../common/selectdb/selectdbAtions').getGrupoFisicoList,
      getConfControladorGrupoList: require('../common/selectdb/selectdbAtions').getConfControladorGrupoList,
    },
    dispatch,
  );

const SelectConfGrupoFisicoLogConnected = connect(
  mapStateToPropsGrupo,
  mapDispatchToPropsGrupo,
)(SelectConfGrupoFisicoLog);

// Componente customizado do SelectConfControlador apenas para esta tela
class SelectConfControladorLog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: this.props.getConfig('cont'),
    };
  }

  componentWillMount() {
    this.props.getConfControladorGrupoList();
  }

  renderOptions() {
    const list = this.props.list || [];
    const anel = this.props.anel !== false;

    if (list.length === 0) {
      return <option value="">Carregando...</option>;
    }

    let listCont = [];
    let firstAnel = null;

    list.forEach(cont => {
      //se não exibe aneis então ajusta o valor selecionado
      if (!anel) {
        if (cont.anel === 1) {
          firstAnel = cont.id;
        } else if (cont.id === +this.state.value) {
          this.props.setConfig('cont', firstAnel);
          this.setState({ value: firstAnel });
        }
      }

      listCont.push(cont);
    });

    return listCont.map(contro => (
      <option
        key={contro.id}
        value={contro.id}
        data-numero={contro.numero_controlador}
        data-anel={contro.anel}
        data-latitude={contro.latitude}
        data-longitude={contro.longitude}
        style={{ display: anel || contro.anel === 1 ? '' : 'none' }}
      >
        {`${contro.numero_controlador} - ${contro.endereco}`}
      </option>
    ));
  }

  handleChange(event) {
    let changed = this.props.getConfig('cont') !== event.target.value;
    this.setState({ value: event.target.value });
    this.props.setConfig('cont', event.target.value);
    this.props.setConfig('numCont', event.target.selectedOptions[0].getAttribute('data-numero'));
    this.props.setConfig('anel', event.target.selectedOptions[0].getAttribute('data-anel'));
    this.props.setConfig('contLat', event.target.selectedOptions[0].getAttribute('data-latitude'));
    this.props.setConfig('contLong', event.target.selectedOptions[0].getAttribute('data-longitude'));

    if (changed && this.props.onChange) {
      this.props.onChange(event.target.value);
    }
  }

  render() {
    return (
      <div className="form-group" style={{ margin: 0 }}>
        <select
          id={'selectConfControladorLog'}
          name={'selectConfControladorLog'}
          style={{
            width: '300px',
            height: '32px',
            padding: '4px 8px',
            fontSize: '13px',
            fontWeight: '600',
            border: '2px solid rgba(255, 255, 255, 0.4)',
            borderRadius: '4px',
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            color: '#333',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          }}
          className={'form-control'}
          onChange={event => {
            this.handleChange(event);
          }}
          value={this.state.value}
        >
          <option value="0">Todos</option>
          {this.renderOptions()}
        </select>
      </div>
    );
  }
}

// Conecta o componente customizado com o Redux
const mapStateToProps = state => ({ list: state.controladorCad.listConf });
const mapDispatchToPropsControlador = dispatch =>
  bindActionCreators(
    {
      getConfControladorGrupoList: require('../common/selectdb/selectdbAtions').getConfControladorGrupoList,
    },
    dispatch,
  );

const SelectConfControladorLogConnected = connect(
  mapStateToProps,
  mapDispatchToPropsControlador,
)(SelectConfControladorLog);

class LogUsuario extends Component {
  constructor(props) {
    super(props);
    this.handleFilterChange = this.handleFilterChange.bind(this);
  }

  componentWillMount() {
    this.props.init();
  }

  // Função para lidar com mudança de filtros
  handleFilterChange = e => {
    // Recarrega a lista quando os filtros mudarem
    this.props.init();
  };

  render() {
    return (
      <div>
        <div className="contentHeaderFilter top-filter log-usuario-filter">
          <SelectConfGrupoFisicoLogConnected
            onChange={this.handleFilterChange}
            getConfig={require('../configuracao/configLocal').getConfig}
            setConfig={require('../configuracao/configLocal').setConfig}
          />
          <SelectConfControladorLogConnected
            anel={false}
            onChange={this.handleFilterChange}
            getConfig={require('../configuracao/configLocal').getConfig}
            setConfig={require('../configuracao/configLocal').setConfig}
          />
        </div>
        <Content>
          <Tabs>
            <TabsHeader>
              <TabHeader label="Listar" icon="bars" target="tabList" />
              <PermissaoUsuario tela="CadLogUsuario" condicao={true}>
                <TabHeader label="Incluir" icon="plus" target="tabCreate" />
                <TabHeader label="Alterar" icon="pencil-alt" target="tabUpdate" />
              </PermissaoUsuario>
            </TabsHeader>
            <TabsContent>
              <TabContent id="tabList">
                <List />
              </TabContent>
            </TabsContent>
          </Tabs>
        </Content>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({ init }, dispatch);
export default connect(
  null,
  mapDispatchToProps,
)(LogUsuario);
